import Image from "next/image";
import ProductDetailsRight from "../products/ProductDetailsRight";
import {useTranslations} from 'next-intl';

export default function ProductDetailsQuick({ product, clientType }) {
  const t = useTranslations('modal');
  
  return (
    <div className="ltn__modal-area ltn__quick-view-modal-area">
      <div className="modal fade" id="quick_view_modal">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                // title={t('close')}
                aria-label={t('close')}
              >
                <span>&times;</span>
              </button>
            </div>
            {
              !product ? '' : (
                  <div className="modal-body">
                    <div className="ltn__quick-view-modal-inner">
                      <div className="modal-product-item">
                        <div className="row">
                          <div className="col-lg-6 col-12">
                            <div className="modal-product-img">
                              <Image
                                  src={product.coverImage}
                                  alt={product.title}
                                  width={1000}
                                  height={1000}
                                  loading="lazy"
                                  style={{height: 'auto', aspectRatio: 1, objectFit: 'cover'}}
                              />
                            </div>
                          </div>
                          <div className="col-lg-6 col-12">
                            <ProductDetailsRight
                                product={product}
                                isModal
                                clientType={clientType}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
              )
            }
          </div>
        </div>
      </div>
    </div>
  );
};
